import React, { useEffect, useRef, useState } from 'react';
import DisplayTemplate from '../displayTemplate';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import HelpText from '../quiz/HelpText';
import Video from './Video';
import Audio from './Audio';
import Image from './Image';

const useStyles = makeStyles()((theme) => ({
    input: {
        width: '2em',
        height: '2em',
        marginRight: '5px',
        marginTop: '2px',
        marginBottom: '3px',
        textAlign: 'center',
        border: 'none',
        borderBottom: "3px solid rgba(205, 230, 245, 1)",
        fontWeight: '700',
        '&:disabled': {
            backgroundColor: 'transparent',
        },
    },
}));

export default function FIBText({ content, length, value, disabled, handleAnswerSelection, contentType, renderDefault = false, language, contentDisplayType, contentUrl, mediaStyle, overrideHTML, helpText, templateType, ...props }) {
    const theme = useTheme();
    const { classes } = useStyles();

    const Blank = ({ length, defaultValue, onComplete }) => {
        const [inputs, setInputs] = useState(Array(length).fill(''));
        const val = useRef(defaultValue && defaultValue.length ? defaultValue : Array(length).fill(''))

        const checkCompletion = (values) => {
            let filled = values.filter(x => x !== '').length;
            if (filled === length && (String(val.current.join('')).toLowerCase() != String(values.join('')).toLowerCase())) {
                if (onComplete && typeof onComplete === 'function') {
                    onComplete(values)
                }
            }
        }

        const handleChange = (e, index) => {
            if (e.target.value !== '') {

                const newInputValue = [...inputs];
                newInputValue[index] = e.target.value;
                setInputs(newInputValue);

                if (e.target.nextSibling) {
                    e.target.nextSibling.focus();
                }

                checkCompletion(newInputValue)
            }
        };

        const handleKeyDown = (e, index) => {
            if (e.key === 'Backspace') {
                const newInputValue = [...inputs];
                newInputValue[index] = '';
                setInputs(newInputValue);

                if (e.target.previousSibling) {
                    e.target.previousSibling.focus();
                }
            }
        };

        useEffect(() => {
            if (defaultValue && defaultValue.length) {
                setInputs(defaultValue)
            }
            // setInputs(defaultValue)
        }, [defaultValue])

        return (<span style={{ marginLeft: '.5rem', marginRight: '.5rem' }}>
            {[...Array(length)].map((_, inputIndex) => (
                <input
                    key={inputIndex}
                    type="text"
                    maxLength="1"
                    value={inputs[inputIndex]}
                    onChange={(e) => handleChange(e, inputIndex)}
                    onKeyDown={(e) => handleKeyDown(e, inputIndex)}
                    disabled={disabled}
                    className={classes.input}
                />
            ))}
        </span>)
    }

    const Component = () => {
        const completedCount = useRef(0);
        const idxWithValuesTracker = useRef({});
        const [inputValues, setInputValues] = useState({});

        const handleSaveByIndex = (index, value) => {
            idxWithValuesTracker.current[index] = value
            completedCount.current++;

            if (completedCount.current >= Object.keys(inputValues).length) {
                let sorted = Object.entries(idxWithValuesTracker.current)
                    .sort(([a], [b]) => Number(a) - Number(b))
                    .map(([_, value]) => value);
                return handleAnswerSelection({ target: sorted })
            }
        }

        useEffect(() => {
            console.log('FIB value received:', value);

            if (value && Object.keys(value).length > 0) {
                // Get the first (and likely only) key-value pair
                const firstKey = Object.keys(value)[0];
                const val = value[firstKey]; // This should be the array of arrays

                console.log('Processed val:', val);

                if (Array.isArray(val) && val.length > 0) {
                    let idx = 0;
                    content.split(/\{(\d+)}/g).map((v, i) => {
                        if (v && !isNaN(v)) {
                            // val[idx] should be an array of characters
                            idxWithValuesTracker.current[i] = val[idx] || Array(Number(v)).fill("")
                            console.log(`Setting index ${i} to:`, val[idx]);
                            idx++;
                        }
                    })
                    setInputValues(idxWithValuesTracker.current)
                    console.log('Final inputValues:', idxWithValuesTracker.current);
                }
            } else if (content) {
                content.split(/\{(\d+)}/g).map((v, i) => {
                    if (v && !isNaN(v)) {
                        idxWithValuesTracker.current[i] = Array(Number(v)).fill("")
                    }
                })
                setInputValues(idxWithValuesTracker.current)
            }
        }, [value, content])

        const TextComponent = () => (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row!important',
                    justifyContent: 'center',
                    gap: '10px',
                    [theme.breakpoints.down('md')]: {
                        flexDirection: 'column',
                        alignItems: 'start',
                        gap: '15px'
                    },
                    ...props.style
                }}
            >
                <Grid item>
                    {
                        content.split(/\{(\d+)}/g).map((part, index) => {
                            if (index % 2 === 1) {
                                const number = parseInt(part);
                                return <Blank key={index} length={number} defaultValue={inputValues[index]} onComplete={(e) => handleSaveByIndex(index, e)} />;
                            } else {
                                return part;
                            }
                        })
                    }
                </Grid>
                {/* <Grid item xs={1}> */}
                {/* <HelpText data={helpText} /> */}
                {helpText && (helpText.text || helpText.contentURL || helpText.overrideHTML) &&
                    <HelpText data={helpText} />
                }
                {/* </Grid> */}
            </Box>
        );

        const MediaComponent = () => {
            if (!contentUrl) return null;

            if (contentUrl.includes('youtube.com') || contentUrl.includes('youtu.be') || contentUrl.includes('.mp4')) {
                return <Video contentUrl={contentUrl} renderDefault={true} />;
            }
            if (contentUrl.includes('.mp3') || contentUrl.includes('.wav')) {
                return <Audio contentUrl={contentUrl} renderDefault={true} />;
            }
            if (contentUrl.includes('.jpg') || contentUrl.includes('.png') || contentUrl.includes('.gif')) {
                return <Image contentUrl={contentUrl} renderDefault={true} />;
            }
            return null;
        };

        const components = contentUrl ? [TextComponent, MediaComponent] : [TextComponent];

        return (
            <Grid item xs={12} sx={{ marginBottom: '1rem' }} container justifyContent="center">
                <DisplayTemplate templateType={templateType} components={components} {...props} />
            </Grid>
        );
        // return (
        //     <Grid item xs={12} sx={{ marginBottom: '1rem' }} container justifyContent="center">
        //         <Grid item xs={12} style={{ paddingTop: 0 }} textAlign={'center'}>
        //             <Box
        //                 sx={{
        //                     display: 'flex',
        //                     flexDirection: 'row!important',
        //                     justifyContent: 'center',
        //                     gap: '10px',
        //                     [theme.breakpoints.down('md')]: {
        //                         flexDirection: 'column',
        //                         alignItems: 'start',
        //                         gap: '15px'
        //                     },
        //                     ...props.style
        //                 }}
        //             >
        //                 <Grid item>
        //                     {
        //                         content.split(/\{(\d+)}/g).map((part, index) => {
        //                             if (index % 2 === 1) {
        //                                 const number = parseInt(part); // Convert the matched number string to an integer
        //                                 return <Blank key={index} length={number} defaultValue={inputValues[index]} onComplete={(e) => handleSaveByIndex(index, e)} />;
        //                             } else {
        //                                 return part; // Keep non-number parts as is
        //                             }
        //                         })
        //                     }
        //                 </Grid>
        //                 {/* <Text content={content} renderDefault={true}/> */}
        //                 <Grid item xs={1}>
        //                     <HelpText data={{ text: helpText?.text }} />
        //                 </Grid>
        //             </Box>
        //         </Grid>
        //     </Grid>
        // );
    }

    return renderDefault ? <Component /> : <DisplayTemplate templateType={templateType} components={[Component]} {...props} />
}